import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnPickerView as UICnPickerView } from './picker-view';
import './picker-view.scss';
export var CnPickerView = withI18n(UICnPickerView, { locale: locale });
